<template>
  <div>
    <div class="banner">
      <div class="swiper-container banner-slider">
        <ul class="swiper-wrapper">
          <li class="swiper-slide" style="background-image:url(https://fs.58keeper.com/banner1.jpg)">
            <div class="banner-inner center">
              <h1 data-scroll-reveal="enter bottom over .5s after 0.1s">让闲散资源创造价值</h1>
              <p data-scroll-reveal="enter bottom over .6s after 0.1s">盘活海南闲置房产，为房东创造收入的同时，给游客提供更具特色的住宿环境</p>
            </div>
          </li>
          <li class="swiper-slide" style="background-image:url(https://fs.58keeper.com/banner2.jpg)">
            <div class="banner-inner center">
              <h1 data-scroll-reveal="enter bottom over .5s after 0.1s">专注房屋托管</h1>
              <p data-scroll-reveal="enter bottom over .6s after 0.1s">闲置房屋交给我们，15天一次免费深度保养，长短租结合帮您赚钱</p>
            </div>
          </li>
          <li class="swiper-slide" style="background-image:url(https://fs.58keeper.com/banner3.jpg)">
            <div class="banner-inner center">
              <h1 data-scroll-reveal="enter bottom over .5s after 0.1s">美妙旅程组成部分</h1>
              <p data-scroll-reveal="enter bottom over .6s after 0.1s">提供海南全岛高性价比特色民宿，可洗衣做饭</p>
            </div>
          </li>
        </ul>
        <div class="swiper-pagination"></div>
      </div>
    </div>

    <div class="section about-section">
      <div class="com-container">
        <div class="row">
          <div class="col-md-6">
            <div class="com-txt">
              <h2 class="title"></h2>
              <p>
                “让闲散资源创造价值”<br>
                作为多妙的企业使命，我们希望解决业主对于投资的旅游地产后的房产控制问题。例如：长租不放心，短租事太多，无暇养护导致的房间损耗，未享受物业服务却不得不缴纳物业费等等问题。
              </p>
              <a href="#/about" class="btn">MORE</a>
            </div>
          </div>
          <div class="col-md-6 img-box">
            <div class="img-box img">
              <img class="about-img" src="https://fs.58keeper.com/smindex1.jpg" alt="多妙">
            </div>
          </div>
        </div>
        <div class="about-img2">
          <img src="https://fs.58keeper.com/smindex2.jpg" alt="多妙">
        </div>
      </div>
    </div>
    <div class="section product-section">
      <div class="com-container">
        <h2 class="com-title">产品与服务</h2>
        <a href="#/franchise" class="btn rightBtn">MORE</a>
        <div class="swiper-container slider2 my-swiper">
          <ul class="swiper-wrapper">
            <li class="swiper-slide">
              <div class="img">
                <img src="https://fs.58keeper.com/product1.jpg" alt="多妙">
              </div>
              <div class="content-txt">
                <h2 class="title">大管家plus</h2>
                <p>房屋一站式智慧托管SaaS管理系统，为闲散资源赋能，协调房东、房源、员工的中台智慧系统。</p>
                <a href="#/franchise" class="btn">MORE</a>
              </div>
            </li>
            <li class="swiper-slide">
              <div class="img">
                <img src="https://fs.58keeper.com/product2.jpg" alt="多妙">
              </div>
              <div class="content-txt">
                <h2 class="title">多妙旅租</h2>
                <p>优选房东度假闲置房，海南度假新选择，租房新风尚。</p>
                <a href="#/discount" class="btn">MORE</a>
              </div>
            </li>
            <li class="swiper-slide">
              <div class="img">
                <img src="https://fs.58keeper.com/product3.jpg" alt="多妙">
              </div>
              <div class="content-txt">
                <h2 class="title">配套服务</h2>
                <p>家政保洁、旅行租车户外、特产采购等配套业务，服务周到。</p>
                <a href="#/contact" class="btn">MORE</a>
              </div>
            </li>
          </ul>
          <div class="swiper-pagination"></div>
        </div>
      </div>
    </div>
    <div class="section brand-section">
      <div class="com-container">
        <div class="row">
          <div class="col-md-6">
            <div class="com-txt">
              <h2 class="title">关于我们</h2>
              <p>90年创业团队，最懂旅游地产的民宿运营商。专注房屋养护与经营。富有激情，勇于挑战。</p>
              <a href="#/about" class="btn">MORE</a>
            </div>
          </div>
          <div class="col-md-6 img-box">
            <div class="img-box">
              <div class="brand-sbg">
                <img class="about-img" src="https://fs.58keeper.com/wmbg1.jpg" alt="多妙">
              </div>
              <img class="about-img" src="https://fs.58keeper.com/wmbg2.jpg" alt="多妙">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section product-content">
      <div class="com-container">
        <div class="t-center">
          <h2>经过努力的耕耘，我们取得了以下数据</h2>
          <p>兢兢业业，利他坚持</p>
          <div class="row product-list">
            <div class="col-md-4">
              <a href="javascript:;">
                <img src="../images/p1.png" alt="多妙">
                <p>累计服务房东超过1000+，托管房源超500+</p>
              </a>
            </div>
            <div class="col-md-4">
              <a href="javascript:;">
                <img src="../images/p2.png" alt="多妙">
                <p>与20+家知名物业公司成为战略合作伙伴</p>
              </a>
            </div>
            <div class="col-md-4">
              <a href="javascript:;">
                <img src="../images/p3.png" alt="多妙">
                <p>累计接待游客10000+，有口皆碑</p>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'
export default {
  name: 'index',
  data: function () {
    return {}
  },
  methods: {
  },
  mounted () {
    new Swiper ('.swiper-container', {
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          let showIndex
          if (index < 9) {
            showIndex = '0' + (index + 1)
          } else {
            showIndex = index + 1
          }
          return '<span class="' + className + '"><i>' + showIndex + '</i></span>'
        }
      },
      scrollbar: '.swiper-scrollbar',
      speed: 1000,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },
      loop: true
    })
  }
}

</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Index.vue